import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const pageWrapperHorizontalPadding = space.s24;

export const pageContentMaxWidth = 960;

export const pageWrapper = style({
  flexGrow: 1,
  padding: `${space.s12}px ${pageWrapperHorizontalPadding}px ${space.s48 * 2}px ${pageWrapperHorizontalPadding}px`,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: themeVars.base.background,
});
export const page = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s20,
  flexGrow: 1,
  width: '100%',
  maxWidth: pageContentMaxWidth,
  margin: '0 auto',
});

export const content = style({
  minHeight: 0,
  flexGrow: 1,
});
